<template>
    <div class="row">
        <div class="col-12 col-md-4">
            <div class="form-group">
                <label for="competition" v-text="competitionType"></label>
                <select name="competition" id="competition" class="selectpicker form-control" v-model="competition" data-live-search="true" @change="redirect()">
                    <option value="">All</option>
                    <option :value="competition.slug" v-for="competition in filteredCompetitions" :key="competition.slug">{{competition.title}}</option>
                </select>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            competition: '',
        }
    },

    props: [
        'category', 'competitions', 'competitionType', 'url'
    ],


    computed: {
        filteredCompetitions() {
            var competitions = [];
            for (const key in this.competitions) {
                if (this.competitions.hasOwnProperty(key)) {
                    const element = this.competitions[key];
                    if(this.category === '' || element.type == this.category) {
                        competitions.push(element);
                    }
                }
            }
            setTimeout(function (){
                $('.selectpicker').selectpicker('refresh');
            }, 200); 
            return competitions;
        },
    },

    created() {
    },

    mounted() {
        setTimeout(function (){
            $('.selectpicker').selectpicker('refresh');
        }, 500);     
    },

    watch: {
    },

    methods: {
        redirect() {
            window.location = this.url + '/' + this.competition; // redirect
        }
    },
}
</script>
